export default {
  rollover: {
    title: 'Rollover',
    detailsTitle: 'Rollover Details',
    all: 'All',
    allStats: 'All Stats',
    select: 'Select',
    rolloverType: 'Rollover Type',
    amount: 'Amount',
    source: 'Source',
    wallet: 'Wallet',
    current: 'Current',
    wagered: 'Wagered',
    required: 'Required',
    progress: 'Progress',
    loading: 'Loading...',
    noData: 'No data',
    noMoreData: 'No more data',
    state: 'State',
    type: 'Type',
    createdOn: 'Created On',
    wageringRequirement: 'Wagering Requirement',
    currency: 'Currency',
    wagerRequired: 'Wager Required',
    wagerCompleted: 'Wager Completed',
    cash: 'Cash',
    bonus: 'Bonus',
  },
};
